import { DedicatedBookingPage } from "@/components/booking/DedicatedBookingPage";

export default function BookingExecutivePresence() {
  return <DedicatedBookingPage service="executive_presence" />;
}
